import { POSTAPI } from "../config/Api";
import { ApiConstants } from "../constants/ApiConstants";
import { PAGINATION } from "../constants/Constants";
import {
  getInflightPromise,
  startBootstrapRequest,
  tryGetCachedBundle,
  type PendingDashboardBundle,
} from "./pendingDashboardBootstrapState";

export type { PendingDashboardBundle };
export { invalidatePendingDashboardBootstrapCache } from "./pendingDashboardBootstrapState";

/**
 * One shared fetch (profile + orders list + quote drafts) for the pending-actions bar.
 * Reuses in-flight promise and short TTL cache so navigating home ↔ other routes does not re-hit APIs every time.
 */
export function getPendingDashboardBootstrap(): Promise<PendingDashboardBundle> {
  const cached = tryGetCachedBundle();
  if (cached) {
    return Promise.resolve(cached);
  }
  const existing = getInflightPromise();
  if (existing) {
    return existing;
  }

  const orderPayload = {
    status: "",
    start_date: "",
    end_date: "",
    search: "",
    page: PAGINATION.PAGE,
    pageSize: PAGINATION.PAGESIZE,
  };
  const quotesPayload = {
    search: "",
    page: PAGINATION.PAGE,
    pageSize: 25,
    orderDirection: "DESC",
  };

  return startBootstrapRequest(
    Promise.all([
      POSTAPI(ApiConstants.Profile, {}, false),
      POSTAPI(ApiConstants.OrderGet, orderPayload, false),
      POSTAPI(ApiConstants.QuotesDraftList, quotesPayload, false),
    ])
  );
}
